import { useState } from "react";
import { toast } from "sonner";
import { Check, MessageSquare, GitCommitHorizontal, ListTodo, Sparkles, Merge, Phone as IconeAppel, MessageCircle, Mail, Smartphone, FileText, History } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { formatDateHeure } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

const ICONES = { commentaire: MessageSquare, etape: GitCommitHorizontal, tache: ListTodo, creation: Sparkles, fusion: Merge, appel: IconeAppel, sms: Smartphone, whatsapp: MessageCircle, email: Mail, document: FileText, historique: History };

export const ProchaineAction = ({ fiche, onPlanifier, onMaj }) => {
  const pa = fiche.prochaine_action;
  const terminer = async () => {
    try { await api.post(`/taches/${pa.id}/terminer`, { fait: true }); toast.success("Action faite. Pensez à planifier la suivante."); onMaj(); }
    catch (e) { toast.error(messageErreur(e)); }
  };
  return (
    <div className="at-card p-5" data-testid="next-action-card">
      <p className="at-label">Prochaine action</p>
      {pa ? (
        <div className="flex items-center justify-between gap-3 mt-2">
          <div className="min-w-0">
            <p className="font-bold" data-testid="next-action-label">{pa.type_label}{pa.note ? ` · ${pa.note}` : ""}</p>
            <p className="text-sm at-muted">{formatDateHeure(pa.echeance)}</p>
          </div>
          <button type="button" onClick={terminer} className="at-btn at-btn-primary shrink-0" data-testid="next-action-done"><Check size={16} />Fait</button>
        </div>
      ) : (
        <div className="flex items-center justify-between gap-3 mt-2">
          <p className="font-bold" style={{ color: fiche.sans_action ? "var(--danger)" : "var(--muted)" }} data-testid="next-action-none">{fiche.sans_action ? "Sans action" : "Aucune action (fiche clôturée)"}</p>
          <button type="button" onClick={onPlanifier} className="at-btn at-btn-ghost shrink-0" data-testid="next-action-plan">Planifier</button>
        </div>
      )}
    </div>
  );
};

export const FilActivite = ({ ficheId, items, onMaj }) => {
  const [texte, setTexte] = useState("");
  const { user } = useAuth();
  const reponse = async (canal) => {
    try {
      const { data } = await api.post(`/fiches/${ficheId}/reponse-client`, { canal });
      toast.success(`Réponse reçue : « ${data.texte} »`, { description: `Résumé IA : ${data.resume}${data.propositions.length ? ` · ${data.propositions.length} proposition(s) dans « Mon assistant »` : ""}` });
      onMaj(); window.dispatchEvent(new Event("assistant:maj"));
    } catch (err) { toast.error(messageErreur(err)); }
  };
  const envoyer = async (e) => {
    e.preventDefault();
    try { await api.post(`/fiches/${ficheId}/commentaires`, { texte }); setTexte(""); onMaj(); }
    catch (err) { toast.error(messageErreur(err)); }
  };
  return (
    <div className="at-card p-5" data-testid="activity-feed">
      <p className="at-label mb-3">Fil d'activité</p>
      {user.role !== "partenaire" && (
        <div className="mb-3" data-testid="simulate-client-reply">
          <p className="text-xs at-muted mb-1.5">Simuler une réponse du client :</p>
          <div className="grid grid-cols-3 gap-2">
            {[["sms", "SMS"], ["whatsapp", "WhatsApp"], ["email", "E-mail"]].map(([c, l]) => (
              <button key={c} type="button" onClick={() => reponse(c)} className="at-btn at-btn-ghost !px-2 text-sm" data-testid={`simulate-reply-${c}`}>{l}</button>
            ))}
          </div>
        </div>
      )}
      <form onSubmit={envoyer} className="flex gap-2 mb-4">
        <input value={texte} onChange={(e) => setTexte(e.target.value)} placeholder="Ajouter un commentaire…" className="at-input" data-testid="comment-input" />
        <button type="submit" disabled={!texte.trim()} className="at-btn at-btn-primary shrink-0" data-testid="comment-submit">Envoyer</button>
      </form>
      <ol className="space-y-3">
        {items.map((a) => {
          const Icone = ICONES[a.type] || Sparkles;
          return (
            <li key={a.id} className="flex gap-3" data-testid={`activity-${a.id}`}>
              <span className="w-9 h-9 shrink-0 at-pill flex items-center justify-center" style={{ background: "var(--surface-2)" }}><Icone size={15} /></span>
              <div className="min-w-0">
                <p className="text-sm break-words">{a.texte}</p>
                <p className="text-xs at-muted mt-0.5">{a.auteur_nom}{a.auteur_type === "ia" ? " (IA)" : ""} · {formatDateHeure(a.date)}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
